import React, { ReactNode, FC, useState, useMemo, ComponentType } from 'react';
import { BadgeProps } from 'ia-react-core/~/components/notification/Badge';
import { SCP } from 'ia-react-core/~/interfaces/SCP';
import { IconButtonProps } from '../IconButton';

import { StyledIconButton, StyledBadge } from './BadgeButton.styles';

export interface BadgeButtonProps extends Omit<IconButtonProps, 'label'>, Omit<BadgeProps, keyof SCP<'div'>> {
  /** Content of the badge. */
  children?: ReactNode;
  /** Text describing the action of the button. */
  label?: string;
  /** Icon with the corner slicpped to use when the badge is visible. */
  ClippedIcon?: ComponentType;
}

const BadgeButton: FC<BadgeButtonProps> = ({
  children, label, badgeType, unreadText, maxCount, Icon, ClippedIcon, ...props
}) => {
  const [badgeInfo, setBadgeInfo] = useState<{
    count?: ReactNode;
    content?: ReactNode;
    label?: string;
  }>({});
  const shouldClip = useMemo(() => Number(children) > 0, [children]);
  const { label: badgeLabel } = badgeInfo;

  return (
    <StyledIconButton
      label={label || badgeLabel || 'Notifications'}
      Icon={(shouldClip && ClippedIcon) ? ClippedIcon : Icon}
      data-testid="BadgeButton"
      {...props}
    >
      {children && (
        <StyledBadge
          aria-hidden="true"
          badgeType={badgeType}
          unreadText={unreadText}
          maxCount={maxCount}
          onBadgeChange={setBadgeInfo}
        >
          {children}
        </StyledBadge>)}
      {label}
    </StyledIconButton>
  );
};

export default BadgeButton;
